import { Theme, styled } from '@nexelem/deprecated-theme';
import { GridRow } from '@mui/x-data-grid-pro';
import { useCallback } from 'react';
import { AVAILABLE_TABLE_ROW_COLORS } from '../../../constants';

export type RowProps = {
  readonly isHoverable?: boolean;
};

export const StyledRow = styled(GridRow)<RowProps>(({ theme, isHoverable }) => {
  const typedTheme = theme as Theme;
  const { common, body, additionalColors } = typedTheme.client.table;
  const { getColor } = typedTheme.palette;
  return {
    //TODO: remove getColor
    backgroundColor: getColor(common.backgroundColor),
    borderBottom: `${theme.spacing(0.25)} solid ${getColor(common.border)}`,
    color: getColor(body.mainTextColor),
    ...typedTheme.typography.sourceSansPro16Regular,
    '&.MuiDataGrid-row': {
      borderBottom: '1px solid #EEEFF2',
      '&:hover': {
        backgroundColor: isHoverable ? getColor(additionalColors.hoverBg) : 'transparent',
        '&& > div': {
          backgroundColor: isHoverable ? getColor(additionalColors.hoverBg) : 'transparent',
        },
      },
      '&.Mui-selected': {
        '> div': {
          backgroundColor: getColor(additionalColors.selectedBg),
        },
        '&&:hover > div': {
          backgroundColor: getColor(additionalColors.selectedBg),
        },
        '&& .MuiDataGrid-cell--pinnedLeft, && .MuiDataGrid-cell--pinnedRight': {
          backgroundColor: getColor(additionalColors.selectedBg),
        },
      },
      [`&.${AVAILABLE_TABLE_ROW_COLORS.coolGray5}`]: {
        backgroundColor: getColor(additionalColors.grayBg05),
        '&& .MuiDataGrid-cell--pinnedLeft, && .MuiDataGrid-cell--pinnedRight': {
          backgroundColor: getColor(additionalColors.grayBg05),
        },
      },
      [`&.${AVAILABLE_TABLE_ROW_COLORS.coolGray10}`]: {
        backgroundColor: getColor(additionalColors.grayBg10),
      },
      '&&&.rowGrouped': {
        '> div': {
          backgroundColor: getColor(body.groupRowBackground),
        },
        '&:hover > div': {
          backgroundColor: getColor(additionalColors.hoverBg),
        },
        '&.Mui-selected': {
          backgroundColor: getColor(additionalColors.selectedBg),
          '&:hover': {
            backgroundColor: getColor(additionalColors.selectedBg),
          },
        },

        '&:not(:has(+.singleRow))': {
          borderBottom: getColor(body.groupRowBackground),
        },
      },
    },
  };
});

export const useTableRow = (isHoverable = true) =>
  useCallback((props: object) => <StyledRow {...props} isHoverable={isHoverable} />, [isHoverable]);
